import { render, staticRenderFns } from "./PText.vue?vue&type=template&id=2c311607&scoped=true"
import script from "./PText.vue?vue&type=script&lang=js"
export * from "./PText.vue?vue&type=script&lang=js"
import style0 from "./PText.vue?vue&type=style&index=0&id=2c311607&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c311607",
  null
  
)

export default component.exports